<template lang="pug">
.basket-banner.mobile-banner.mb-8(:class="[ 'banner-' + getRandomArbitrary(1, 3)]", data-qa="step0-banner")
  .banner-title(v-html="$t('BASKET_BANNER_TITLE')", data-qa="step0-banner-title")
  .banner-text(v-html="$t('BASKET_BANNER_TEXT').replace('/basket/', '/checkout_new/')", data-qa="step0-banner-text")
</template>
<script>
export default {
  name: 'BannerBlock',
  methods: {
    getRandomArbitrary(min, max) {
      min = Math.ceil(min)
      max = Math.floor(max)
      return Math.floor(Math.random() * (max - min) + min)
    },
  },
}
</script>
<style>
#appCheckout .basket-banner {
  background:
    linear-gradient(
      90deg,
      rgba(255, 255, 255, 0.75) 0%,
      rgba(255, 255, 255, 0) 80.65%
    ),
    #decfc8;
  border-radius: 12px;
  width: 100%;
  padding: 24px 145px 24px 24px;
  position: relative;
  overflow: hidden;
  min-height: 106px;
  font-family: 'Rubik', serif;
  color: #333f48;
}
#appCheckout .basket-banner:after {
  width: 137px;
  content: '';
  position: absolute;
  right: 12px;
  bottom: -2px;
  height: 106px;
  background-size: contain;
  background-repeat: no-repeat;
}

#appCheckout .basket-banner a {
  color: #ff585d;
  font-weight: 500;
}

#appCheckout .banner-1 {
  background: #f1e8ff;
}
#appCheckout .banner-1:after {
  background-image: url(@/assets/img/banner/banner-girl-1.webp);
}
#appCheckout .banner-2 {
  background: #ededef;
}
#appCheckout .banner-2:after {
  background-image: url(@/assets/img/banner/banner-girl-2.webp);
}
#appCheckout .banner-3 {
  background: #ffeaf0;
}
#appCheckout .banner-3:after {
  background-image: url(@/assets/img/banner/banner-girl-3.webp);
}
#appCheckout .banner-title {
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
}
#appCheckout .banner-text {
  max-width: 605px;
  font-size: 14px;
  line-height: 17px;
}
#appCheckout .banner-text a {
  color: #fa5f55;
  font-weight: 500;
}

@media screen and (max-width: 1024px) {
  #appCheckout .basket-banner.mobile-banner {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
}
@media screen and (max-width: 640px) {
  #appCheckout .basket-banner.mobile-banner {
    padding: 16px;
  }
  #appCheckout .basket-banner.mobile-banner .banner-title,
  #appCheckout .basket-banner.mobile-banner .banner-text {
    padding-right: 95px;
  }
  #appCheckout .mobile-banner:after {
    right: -30px;
  }
  #appCheckout .banner-1:after {
    background-image: url(@/assets/img/banner/banner-girl-1-m.webp);
  }
  #appCheckout .banner-2:after {
    background-image: url(@/assets/img/banner/banner-girl-2-m.webp);
  }
  #appCheckout .banner-3:after {
    background-image: url(@/assets/img/banner/banner-girl-3-m.webp);
  }
}
</style>
